"use client";
import { Button } from "@/components/ui/shadcn/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/shadcn/dialog";
import { KeyRound, UserPlus } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import PermissionSwitch from "./PermissionSwitch";
import UserAvatar from "./UserAvatar";

interface Props {
  scope: string;
  users: { id: string; username: string; scopes: string[]; isAdmin: boolean }[];
}

export function SetAccessButton(props: Props) {
  const [activeUsers, setActiveUsers] = useState(
    props.users.filter(
      (user) => user.isAdmin === true || user.scopes.includes(props.scope)
    )
  );

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link">
          <UserPlus className="size-8" />{" "}
          <span className="hidden sm:inline">Editar acceso</span>
        </Button>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>Usuarios con acceso</DialogTitle>
          <DialogDescription>
            Puedes definir que usuarios tienen acceso a este contenido. Los
            usuarios con permiso de administrador siempre tendrán acceso a todos
            los módulos.
          </DialogDescription>
        </DialogHeader>
        <div>
          <div className="flex flex-col gap-2 h-96 overflow-y-auto border-b">
            {props.users.map((user) => (
              <div className="flex items-center" key={user.id}>
                <div className="flex-1">
                  {user.username}{" "}
                  {user.isAdmin ? (
                    <span className="text-sm text-muted-foreground">ADMIN</span>
                  ) : (
                    ""
                  )}
                </div>
                <PermissionSwitch
                  disabled={user.isAdmin}
                  scope={props.scope}
                  userId={user.id}
                  checked={activeUsers.some((u) => u.id === user.id)}
                  onChange={(checked: boolean) => {
                    setActiveUsers(
                      checked
                        ? [...activeUsers, user]
                        : activeUsers.filter((u) => u.id !== user.id)
                    );
                  }}
                />
              </div>
            ))}
          </div>
          <Link href={`/admin/usuarios`} className="link">
            Administrar usuarios
          </Link>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button>Hecho</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
